export const attendanceData = [
  // { session: 'Session 1', date: '2023-09-25', day: 'Sunday', time: '18:55:54', status: 'Present', signature: null },
  // { session: 'Session 2', date: '2023-09-25', day: 'Sunday', time: '18:55:54', status: 'Present', signature: null },
  // { session: 'Session 3', date: '2023-09-25', day: 'Sunday', time: '18:55:54', status: 'Present', signature: null },
  // { session: 'Session 4', date: '2023-09-25', day: 'Sunday', time: '18:55:54', status: 'Present', signature: null },
  // { session: 'Session 5', date: '2023-09-25', day: 'Sunday', time: '18:55:54', status: 'Present', signature: null },
];

export const tableColumns = ['Session', 'Date', 'From', 'To', 'Status', 'Signature'];

const currentDate = new Date().toISOString().split('T')[0];
attendanceData.push({ session: 'Current Session', date: currentDate, day: '', time: '', status: '', signature: '' });